export default {
  '@class': 'string',
  id: 'number',
  token: 'string',
  images: 'array',
  activity_park_type: 'reference',
  play_areas: 'has-many',
}
